import React, { useCallback, useMemo } from "react";
import ReactDOM from "react-dom";
import { classnames, Icon, PlainButton } from "@culturehq/components";

import { ProfileLink } from "app/links";
import getUserName from "app/utils/getUserName";

const makePhotoTagStyle = (boundingBox, photoTag) => {
  const left = boundingBox.left + boundingBox.width * parseFloat(photoTag.left, 10);
  const top = boundingBox.top + boundingBox.height * parseFloat(photoTag.top, 10);

  if (photoTag.width) {
    const width = boundingBox.width * parseFloat(photoTag.width, 10);
    const height = boundingBox.height * parseFloat(photoTag.height, 10);

    return { left, top, width, height };
  }

  return { left: left - 50, top: top - 50, width: 100, height: 100 };
};

const PhotoTag = ({ boundingBox, onTagDelete, photoTag, tagging }) => {
  const onClick = useCallback(
    event => {
      event.preventDefault();
      event.stopPropagation();
      onTagDelete(photoTag);
    },
    [onTagDelete, photoTag]
  );

  const style = useMemo(
    () => makePhotoTagStyle(boundingBox, photoTag),
    [boundingBox, photoTag]
  );

  return (
    <ProfileLink user={photoTag.user}>
      <div
        className={classnames("chq-photo-tag", { "chq-photo-tag-active": tagging })}
        style={style}
      >
        <PlainButton className="chq-photo-tag--del" onClick={onClick}>
          <Icon icon="ios-close-empty" />
        </PlainButton>
        <div className="chq-photo-tag--name">{getUserName(photoTag.user)}</div>
      </div>
    </ProfileLink>
  );
};

const PhotoTags = ({ boundingBox, containerRef, onTagDelete, photo, tagging }) => (
  ReactDOM.createPortal(
    <>
      {photo.photoTags.map(photoTag => (
        <PhotoTag
          key={photoTag.id}
          boundingBox={boundingBox}
          onTagDelete={onTagDelete}
          photoTag={photoTag}
          tagging={tagging}
        />
      ))}
    </>,
    containerRef.current
  )
);

export default PhotoTags;
